<script setup lang="ts">
    import { getMedia, downloadFile } from '@shopware/helpers';
    import type { Schemas } from '#shopware';

    const props = defineProps<{
        lineItem: Schemas['OrderLineItem'];
    }>();

    defineOptions({ name: 'AccountOrderLineItem' });

    const { getMediaFile } = useOrderDetails(props.lineItem.orderId);
    const { t } = useI18n();

    const getMediaFileHandler = async (mediaId: string, fileName: string) => {
        const response = await getMediaFile(mediaId);
        downloadFile(response, fileName);
    };
</script>

<template>
    <div class="order-info">
        <div class="order-info__product">
            <div
                v-if="lineItem.type == 'product'"
                class="order-info__product__image"
            >
                <ShopwarePicture
                    v-if="lineItem.cover"
                    :media="lineItem.cover"
                    :alt="lineItem.label"
                    type="thumbnail"
                />
            </div>

            <p v-if="lineItem.type == 'promotion'">
                {{ lineItem.label }}<br />
                {{ lineItem.referencedId }}
            </p>
            <p v-else>
                {{ lineItem.label }}
            </p>
        </div>

        <div class="order-info__entry">
            <div class="title">{{ t('account.order.quantity') }}</div>
            <div>{{ lineItem.quantity }}</div>
        </div>

        <div
            v-if="lineItem.unitPrice"
            class="order-info__entry"
        >
            <div class="title">{{ t('account.order.price') }}</div>
            <SharedPrice
                :value="lineItem.unitPrice"
                data-testid="order-item-unitprice"
            />
        </div>

        <div
            v-if="lineItem.totalPrice"
            class="order-info__entry"
        >
            <div class="title">{{ t('account.order.subtotal') }}</div>
            <SharedPrice
                :value="lineItem.totalPrice"
                data-testid="order-item-totalprice"
            />
        </div>
    </div>

    <template
        v-for="media in getMedia(lineItem)"
        :key="media.id"
    >
        <div
            v-if="media.accessGranted"
            class="flex gap-2 cursor-pointer pl-5 pb-3"
            @click="getMediaFileHandler(media.id, media.fileName)"
        >
            <div class="w-5 h-5 i-carbon-result" />
            {{ media.fileName }}
        </div>
    </template>
</template>
